export const buildContactChangePlanUrl = (plan) => {
  const params = new URLSearchParams({ reason: "change_plan" });
  if (plan?.id != null) {
    params.set("planId", String(plan.id));
  }
  return `/nyafaz-brand/contact-us?${params.toString()}`;
};
